import { getAccessToken, resetAccessToken } from '@/helpers/utils';
import { local } from '@/local';
import Vue from '@/main';
import router from '@/routes';
import axios from 'axios';
import qs from 'qs';

axios.defaults.baseURL = process.env.VUE_APP_BE_BASE_URL;
axios.defaults.headers.common.Authorization = getAccessToken();

const getResponseErrorMessages = (error) => {
  if (!error.response || !error.response.status) {
    if (error.message) return local.errors.somethingWentWrong;
    return false;
  }
  const errorData = error.response && error.response.data;
  if (!errorData) return local.errors.somethingWentWrong;
  switch (error.response.status) {
    case 401:
    case 403: {
      return '';
    }
    case 409:
    case 422:
    case 400: {
      if (typeof errorData === 'object') {
        if (errorData.detail) return '- ' + errorData.detail.replace(/,/g, '<br>- ');
        if (typeof errorData.errors === 'object')
          return Object.keys(errorData.errors)
            .reduce((errors, errorKey) => {
              const msg = errorData.errors[errorKey];
              if (Array.isArray(msg)) errors += `- ${msg.join('<br>- ')}`;
              else errors += `- ${msg}`;
              return errors;
            }, ``);
        return local.errors.somethingWentWrong;
      } else return errorData;
    }
    case 500: {
      return local.errors.somethingWentWrong;
    }
    default: {
      return local.errors.somethingWentWrong;
    }
  }
};
const methodsToHaveOverlayLoader = ['post', 'patch', 'put'];

const cancelRequests = {};
axios.interceptors.request.use((config) => { // do something before request is sent
  Vue.appLoader.start();
  try { removeShownProperty(config.data); } catch (error) { }
  if (methodsToHaveOverlayLoader.indexOf(config.method) !== -1) {
    Vue.overlayLoader.start();
  }
  if (config?.params?.serializer) {
    config.paramsSerializer = params => qs.stringify(params, { arrayFormat: config.params.serializer });
    delete config.params.serializer;
  }
  if (!config.cancelToken && !config.skipCancelToken) {
    cancelRequests[config.url] && cancelRequests[config.url]();
    config.cancelToken = new axios.CancelToken(function executor(cancelFunction) {
      cancelRequests[config.url] = cancelFunction;
    });
  }
  return config;
},
  (error) => {
    // do something with request error
    Vue.appLoader.error();
    Vue.overlayLoader.end();
    Vue.toaster.error(local.errors.somethingWentWrong);
    return Promise.reject(error);
  }
);

// add a response interceptor
axios.interceptors.response.use((response) => { // do something with response data
  Vue.appLoader.end();
  Vue.overlayLoader.end();
  return response;
},
  (error) => {
    Vue.appLoader.error();
    Vue.overlayLoader.end();
    if (axios.isCancel(error)) {
      error.handled = true;
      return Promise.reject(error);
    }
    const status = error.response && error.response.status;
    if (status === 401) {
      resetAccessToken();
      location.reload();
    }
    if (status === 403) {
      router.push('/error/403');
    }
    if (status === 404 && error.response.config.method === 'get') return Promise.reject(error);
    if (status === 404 && error.response.config.method === 'head') return Promise.reject(error);

    // do something with response error
    const errorMessage = getResponseErrorMessages(error);
    if (errorMessage) {
      Vue.toaster.error(errorMessage);
      error.message = errorMessage;
      error.handled = true;
    }
    return Promise.reject(error);
  }
);

const removeShownProperty = (obj) => {
  if (typeof obj === 'object' && Array.isArray(obj) && !!obj) (obj || []).forEach((arrElem) => { removeShownProperty(arrElem); });
  if (typeof obj === 'object' && !Array.isArray(obj) && !!obj)
    for (const key in (obj || {})) {
      if (Object.hasOwnProperty.call(obj, key)) {
        if (key === 'shown') delete obj[key];
        else removeShownProperty(obj[key]);
      }
    }
};
